import { AxiosPromise } from "axios";
import api from "shared/api";
import { Settings } from "./models/settings";

const prefix = "api/notifications";

export const getSettings = async (): Promise<Settings> => {
  const res = await api().get<Settings>(`${prefix}/current-user`);
  return res.data;
};

export const postSettings = (settings: Settings): AxiosPromise<void> => {
  return api().post(`${prefix}/current-user`, settings);
};
